import type { ValidAttributeType } from '@web-platform/shared-universal-constants/src/filterAttributes';
import type { FareAttributesFiltersChangedAction } from '@web-platform/shared-universal-types/src/redux/actions/fareAttributes';

export type { FareAttributesFiltersChangedAction };

export const FARE_ATTRIBUTES_FILTER_CHANGED = 'FARE_ATTRIBUTES_FILTER_CHANGED';

export const MUTLIBOOK_OPEN_STATE_CHANGE = 'MUTLIBOOK_OPEN_STATE_CHANGE' as const;

export const fareAttributesFilterChanged = (
  filterState: ValidAttributeType[],
): FareAttributesFiltersChangedAction => ({
  type: FARE_ATTRIBUTES_FILTER_CHANGED,
  payload: {
    filterState,
  },
});
